import { Link, LinkProps } from "react-router-dom";
import { AnchorHTMLAttributes } from "react";

interface CustomLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement> & LinkProps, "to"> {
  to: string;
}

export const CustomLink = ({ to, ...otherProps }: CustomLinkProps): JSX.Element =>
  to.toString().includes("http") ? (
    <a href={to} target={"_blank"} rel={"noreferrer"} {...otherProps} />
  ) : (
    <Link to={to} {...otherProps} />
  );
